import React, { Component } from "react"
import { translate } from "react-i18next"
import Widget from "../Layout/Widget"
import Donut from "../../Graphs/DonutChart"

class AverageEngagementScoreDonut extends Component {
  constructor() {
    super()
    this.state = { hasData: false }
  }
  componentDidMount() {
    // Do api call
    this.loadData()

    this.countdown = setInterval(() => this.loadData(), 5000)
  }

  componentWillUnmount() {
    clearInterval(this.countdown)
  }

  loadData() {
    this.setState({ hasData: !this.state.hasData })
  }

  render() {
    const { t, i18n } = this.props
    const widgetTitle = t("WidgetTitles.AverageEngagement")

    if (!this.state.hasData) {
      return null
    }

    return (
      <Widget title={widgetTitle} widthLg={4} widthMd={4}>
        <Donut
          value={37}
          maxValue={100}
          units="%"
          leftComparisonTitle="Last 6 months"
          leftComparisonValue={55}
          rightComparisonTitle="Last 3 months"
          rightComparisonValue={50}
        />
      </Widget>
    )
  }
}

export default translate("translations")(AverageEngagementScoreDonut)



// WEBPACK FOOTER //
// ./src/Components/Widgets/Performance/AverageEngagementScoreDonut.js